<template>
  <div class="mt-component-form">
    <vs-row class="my-4">
      <h5 style="align-self: center"><i class="dot"></i>{{ title }}</h5>
      <div class="ml-auto">
        <vs-button v-if="!isPrint && !readonly" class="" color="secondary" type="border" @click="handleAddRow">항목추가</vs-button>
        <vs-button v-if="!isPrint && !readonly" class="ml-4" color="secondary" @click="handleRemoveRow">선택삭제</vs-button>
      </div>
    </vs-row>

    <table>
      <colgroup>
        <col v-if="!isPrint" width="40" />
        <col width="60" />
        <col width="200" />
        <col />
        <col width="100" />
        <col width="80" />
        <col width="80" />
        <col width="80" />
        <col />
      </colgroup>
      <thead>
        <th v-if="!isPrint">
          <div class="flex items-center justify-center">
            <vs-checkbox v-if="!isPrint && !readonly" :value="allCheck" @click.native="onClickAllCheckbox" class="vscheck"></vs-checkbox>
          </div>
        </th>
        <th>연번</th>
        <th>점검일</th>
        <th>품명</th>
        <th>수량</th>
        <th>양호</th>
        <th>미흡</th>
        <th>해당없음</th>
        <th>비고(보완계획)</th>
      </thead>
      <tbody>
        <tr v-for="(item, item_i) in list" :key="item_i">
          <td v-if="!isPrint">
            <div class="flex items-center justify-center">
              <vs-checkbox v-if="!item.readonly && !readonly" v-model="checkIndexs" :vs-value="item.id" class="vscheck"></vs-checkbox>
            </div>
          </td>
          <td>{{ item_i + 1 }}</td>
          <td>
            <date-selector v-if="!isPrint" v-model="item.date" class="w-full" :readonly="item.readonly || readonly"></date-selector>
            <p v-else class="print-input">{{ item.date }}</p>
          </td>
          <td>
            <ml-input v-if="!isPrint" v-model="item.name" class="w-full" :readonly="item.readonly || readonly"/>
            <span v-else class="print-input">{{ item.name }}</span>
          </td>
          <td>
            <ml-input v-if="!isPrint" v-model="item.count" class="w-full" :readonly="item.readonly || readonly" type="number"/>
            <span v-else class="print-input">{{ item.count }}</span>
          </td>
          <td><radio-type-check :name="`${title}_${item_i}`" checkValue="양호" :readonly="isPrint || item.readonly || readonly" v-model="item.check" /></td>
          <td><radio-type-check :name="`${title}_${item_i}`" checkValue="미흡" :readonly="isPrint || item.readonly || readonly" v-model="item.check" /></td>
          <td><radio-type-check :name="`${title}_${item_i}`" checkValue="해당없음" :readonly="isPrint || item.readonly || readonly" v-model="item.check" /></td>
          <td>
            <ml-input v-if="!isPrint" v-model="item.etc" class="w-full" :readonly="item.readonly || readonly"/>
            <p v-else class="print-input">{{ item.etc }}</p>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import DateSelector from "@/components/selector/DateSelector.vue";

export default {
  name: "TableProductCheck",
  components: { DateSelector },
  props: {
    title: String,
    isPrint: Boolean,
    readonly: Boolean,
    value: Array,
  },
  data() {
    return {
      list: this.value,
      checkIndexs: [],
      numberId: 0 < this.value.length ? this.value[this.value.length - 1].id : 0,
    };
  },
  computed: {
    allCheck() {
      return 0 < this.list.length && this.list.length === this.checkIndexs.length;
    },
  },
  watch: {
    value: {
      handler(value) {
        this.list = value;
        this.numberId = 0 < value.length ? value[value.length - 1].id : 0;
      },
    },
    list: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },

  methods: {
    // 항목추가
    handleAddRow() {
      this.list.push({ id: ++this.numberId });
    },
    // 선택삭제
    handleRemoveRow() {
      this.list = this.list.filter((item) => item.readonly || !this.checkIndexs.includes(item.id));
      this.checkIndexs = [];
    },

    // 일괄 체크
    onClickAllCheckbox() {
      if (this.allCheck) this.checkIndexs = [];
      else this.checkIndexs = this.list.map((_item, _index) => _item.id);
    },
  },
};
</script>

<style scoped lang="scss">
table {
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;

  &,
  th,
  td {
    border: 1px solid #cdcdcd;
  }

  th {
    font-weight: 500;
    font-size: 14px;
    text-align: center;
    padding: 15px 0;
    background: #f9f9f9;
  }

  td {
    text-align: center;
    padding: 4px;
  }
}

.vscheck::v-deep .vs-checkbox {
  margin-right: 0px;
}
</style>
